import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
  activeId: string;

  constructor(
    public activeModal: NgbActiveModal
  ) {
    this.activeId = 'signup';
  }

  ngOnInit(): void {
  }

  onAction(e: { type: string, key: any }) {
    switch (e.type) {
      case 'switch':
        this.activeId = e.key;
        break;
      case 'close':
        this.activeModal.close(false);
        break;
      case 'redirect':
        this.activeModal.close(true);
        break;
      case 'signedIn':
        this.activeModal.close(true);
        break;
      case 'loggedIn':
        this.activeModal.close(true);
        break;
      case 'paymentComplete':
        this.activeModal.close(true);
        break;
    }
  }

}
